// Shared client-side persistence keys: localStorage (Zustand `persist`) store
// names and the sidebar state cookie name. Centralized so the strings stay in
// sync with any migration/clear logic. Dependency-free.

/** Zustand `persist` key for the auth store (`user` + `session`). */
export const AUTH_STORAGE_KEY = 'auth-storage';

/** Zustand `persist` key for viewed support-ticket ids. */
export const SUPPORT_NOTIFICATIONS_STORAGE_KEY = 'support-notifications';

/** Cookie name for the sidebar open/closed state. */
export const SIDEBAR_COOKIE_NAME = 'sidebar_state';
